import { formatCustomerIdToAccountId } from "../../form/utils/campaign-form-model";

export const SELECTED_CUSTOMER_ID_STORAGE_KEY = "ba-selected-customer-id";
export const SELECTED_CUSTOMER_ID_CHANGED_EVENT =
	"ba-selected-customer-id-changed";

export const getSelectedCustomerAccountId = (): string | null =>
	localStorage.getItem(SELECTED_CUSTOMER_ID_STORAGE_KEY);

export const setSelectedCustomerAccountId = (accountId: string): void => {
	localStorage.setItem(SELECTED_CUSTOMER_ID_STORAGE_KEY, accountId);
	window.dispatchEvent(
		new CustomEvent(SELECTED_CUSTOMER_ID_CHANGED_EVENT, { detail: accountId }),
	);
};

export const setSelectedCustomerAccountIdFromCustomerId = (
	customerId: string,
): void => {
	const formatted = formatCustomerIdToAccountId(customerId);
	if (formatted) setSelectedCustomerAccountId(formatted);
};
